<template>
    <el-main >
        <el-dialog title="用户登录" :visible.sync="this.$store.state.showloginform"  class="mydialog" v-loading="loading" :before-close="handleClose">
            <el-form :model="form">
                <el-form-item label="用户名" :label-width="formLabelWidth">
                    <el-input maxlength="40" placeholder="使用whatsns问答账号登录" v-model="form.username" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="登录密码" :label-width="formLabelWidth">
                    <el-input  maxlength="40" type="password"  v-model="form.password" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancellogin">取 消</el-button>
                <el-button type="primary" @click="loginpost">确 定</el-button>
            </div>
        </el-dialog>
   </el-main>
</template>
  <script>
      import axios from 'axios'
      export default{
          name: 'Login',
          data(){
              return {
                  loading:false,
                  form: {
                      username: '',
                      password: ''
                  },
                  formLabelWidth: '100px'
              }
          },
          methods:{
              handleClose(done) {
                  this.$store.state.showloginform = false
          },
              cancellogin(){
                  this.$store.state.showloginform = false
              },
              loginpost(){
                  this.loading = true

                  var _this = this;
                  // 设置一个开关来避免重负请求数据
                  var sw = true;

                  var params = 'ajax='+encodeURIComponent(JSON.stringify(_this.form));
                  axios.post(this.$store.state.baseurl + 'appstore/postlogin',params).then(function (response) {
                      _this.loading = false
                      if(response.data.match('ok')){

                          _this.$message('登录成功')
                          _this.$store.state.showloginform = false
                          _this.$store.state.loginstate = true
                          var users=response.data.split('|')
                          var accesstoken =users[3]
                          var expiretime=0
                          if(users[4]!=null){
                               expiretime=users[4]
                          }
                          expiretime=expiretime*1000;
                          var timestamp=Date.parse(new Date())
                          if(expiretime>timestamp){
                             console.log(timestamp+"没有过期"+expiretime)
                          }else{
                              console.log(timestamp+"过期!!!"+expiretime)
                          }
                          _this.$store.state.username=users[1]
                          window.localStorage.clear()
                          window.localStorage.setItem("accesstoken",accesstoken)
                          window.localStorage.setItem("username",users[1])
                          window.localStorage.setItem("uid",users[2])
                          window.localStorage.setItem("expiretime",expiretime)
                          window.localStorage.setItem("loginstate",true)
                          _this.$store.state.accesstoken=accesstoken

                          _this.$store.state.uid = users[2]
                          _this.$store.state.username = users[1]
                      }else{
                          _this.$message(response.data);
                      }




                  }).catch(function (error) {
                     console.log(error);
                  });
              }
          }
      }
  </script>


// WEBPACK FOOTER //
// src/components/Login.vue